import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import CssBaseline from '@material-ui/core/CssBaseline';
import Sidebar from './common/components/sidebar/Sidebar';
import { CircularProgress } from "@material-ui/core";
import Navbar from './common/components/navbar/Navbar';
import Content from './common/components/content/Content';
import { createTheme } from '@material-ui/core/styles';
import themeFile from './assets/themes/theme';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { SnackbarProvider } from 'notistack';
import { CookiesProvider } from 'react-cookie';
import { withTranslation } from 'react-i18next';
import Login from "common/components/login/Login";
/* import OAuth2RedirectHandler from "common/components/login/OAuth2RedirectHandler"; */
import { logoutUser } from "views/users/api/apiAuth";
import { getUserInfo } from "views/users/api/apiUsers";

const theme = createTheme(themeFile);

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
      isAuthenticated: false,
      userInfo: null,
      isLoading: false
    }
  }

  componentDidMount() {
    this.getUserInfo()
  }

  getUserInfo() {
    this.setState({ isLoading: true })
    getUserInfo().then(response => {
      this.setState({
        userInfo: response.data.data,
        isAuthenticated: true,
        isLoading: false
      });
    }).catch(error => {
      this.setState({
        isAuthenticated: false,
        isLoading: false
      });
    });
  }

  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen })
  };

  handleLogout() {
    logoutUser().then(response => {
      if (response.request.responseURL.includes('aim.base58.hr')) {
        window.location.href = response.request.responseURL
      }
    }).catch(error => {
      return Promise.reject(error);
    });
    localStorage.removeItem("sidebarCollapseIndex");
  }

  render() {

    if (this.state.isLoading) {
      return (
        <div className="loading-position">
          <CircularProgress className="spinner" color="primary" />
        </div>
      )
    }

    return (
      <MuiThemeProvider theme={theme}>
        <SnackbarProvider maxSnack={3} anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}>
          <CookiesProvider>
            <Router>
              <div className="root">
                <CssBaseline />
                {this.state.isAuthenticated && <>
                  <Navbar title={this.props.t("asset_inventory_manager")} handleDrawerToggle={this.handleDrawerToggle} userInfo={this.state.userInfo} logout={this.handleLogout} />
                  <Sidebar handleDrawerToggle={this.handleDrawerToggle} mobileOpen={this.state.mobileOpen} />
                  <Content userInfo={this.state.userInfo} />
                </>}
                {/* <Route path="/oauth2/redirect" component={OAuth2RedirectHandler}></Route> */}
                {!this.state.isAuthenticated && <Route path="/" render={(props) => <Login isAuthenticated={this.state.isAuthenticated} {...props} />}></Route>}
              </div>
            </Router>
          </CookiesProvider>
        </SnackbarProvider>
      </MuiThemeProvider>
    );
  }
}

export default withTranslation()(App);